




















































































































































































































import _ from 'lodash'
import { Component, Vue, Watch, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { onlyNumber, validateCPF } from '@/utils/common'
import { AnestesistaHospital } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import SuporteAnestesistasStore from '@/components/Suporte/Store/SuporteAnestesistasStore'

@Component

export default class ComponentModalSuporteAnestesistas extends Vue {
  $refs: { getInputSearch: HTMLInputElement, cadastroAnestesistaForm: any }

  anestesistasTableHeader: any[] = [
    { text: 'Nome', align: 'left', value: 'nome', sortable: false },
    { text: 'Documento', align: 'left', value: 'documento', sortable: false },
    { text: 'CRM', align: 'left', value: 'crm', sortable: false },
    { text: 'Status', align: 'center', value: 'status', sortable: false },
  ]

  inputSearch: string = ''
  get getInputSearch() { return this.inputSearch }
  set getInputSearch(value: string) { this.inputSearch = value }

  loadAnestesistas: boolean = false
  get loadingAnestesistas() { return this.loadAnestesistas }
  set loadingAnestesistas(value: boolean) { this.loadAnestesistas = value }

  modalCadastrarAnestesista: boolean = false
  get showModalCadastrarAnestesista() { return this.modalCadastrarAnestesista }
  set showModalCadastrarAnestesista(value: boolean) { this.modalCadastrarAnestesista = value }

  selectedA: AnestesistaHospital = { id: '', nome: '', crm: '', temVinculoHospital: false }
  get selectedAnestesista() { return this.selectedA }
  set selectedAnestesista(value: AnestesistaHospital) { this.selectedA = value }

  selected: any[] = []

  get getSuporteAnestesistasStore() {
    return getModule(SuporteAnestesistasStore, this.$store)
  }

  get showModalAnestesistas() {
    return this.getSuporteAnestesistasStore.modal.anestesistas
  }

  set showModalAnestesistas(value: boolean) {
    this.getSuporteAnestesistasStore.setModal({ name: 'anestesistas', value })
  }

  cadastroAnestesistaForm: any = {
    valid: true,
    nome: [
      (v: any) => !!v || 'Campo obrigatório.',
      (v: any) => v.length >= 5 || 'O campo deve conter pelo menos 5 caracteres.',
    ],
    documento: [
      (v: any) => !!v || 'Campo obrigatório.',
      (v: any) => !!validateCPF(v) || 'Informe um CPF válido',
    ],
    crm: [
      (v: any) => !!v || 'Campo obrigatório.',
      (v: any) => v.length === 9 || 'O campo deve ter o formato: 123456-SP.',
    ],
  }

  novoAnestesista: any = { nome: '', documento: '', crm: '' }
  loadCadastrarAnestesista: boolean = false
  get loadingCadastrarAnestesista() { return this.loadCadastrarAnestesista }
  set loadingCadastrarAnestesista(value: boolean) { this.loadCadastrarAnestesista = value }

  get getAnestesistasApi() {
    return this.getSuporteAnestesistasStore.anestesistas || []
  }

  get getPagina() {
    return this.getSuporteAnestesistasStore.pagina
  }

  set getPagina(value: number) {
    this.getSuporteAnestesistasStore.setPagina(value)
  }

  get getQtdPorPagina() {
    return this.getSuporteAnestesistasStore.qtdPorPagina
  }

  set getQtdPorPagina(value: number) {
    this.getSuporteAnestesistasStore.setQtdPorPagina(value)
  }

  get getTotalAnestesistas() {
    return this.getSuporteAnestesistasStore.totalAnestesistas
  }

  get anestesistasLength() {
    return Math.ceil(this.getTotalAnestesistas / this.getQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(pagina: number) {
    this.loadingAnestesistas = true
    this.getPagina = pagina
    await this.getSuporteAnestesistasStore.getAllAnestesistas()
    this.loadingAnestesistas = false
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  debounce = _.debounce(input => this.getSuporteAnestesistasStore.getAllAnestesistas(input), 600)

  search() {
    if (this.inputSearch.length === 0 || this.inputSearch.length > 2) {
      this.debounce(this.inputSearch)
    }
  }

  resetSearch() {
    this.getInputSearch = ''
    this.debounce(this.inputSearch)
  }

  resetSelectedAnestesista() {
    this.selectedAnestesista = { id: '', nome: '', crm: '', temVinculoHospital: false }
  }

  async cadastrarAnestesista() {
    this.loadingCadastrarAnestesista = true
    const isValid = this.$refs.cadastroAnestesistaForm.validate()
    if (!isValid) {
      this.loadingCadastrarAnestesista = false
      return
    }

    const payload: any = {
      nome: this.novoAnestesista.nome,
      documento: this.novoAnestesista.documento,
      crm: this.novoAnestesista.crm,
    }

    const request = await this.getSuporteAnestesistasStore.postAnestesista(payload)
    EventBus.$emit('setSnackbar', {
      show: true,
      text: request.success ? 'Cadastrado com sucesso! Agora você pode selecioná-lo na lista.' : request.message,
      icon: request.success ? 'done' : 'warning',
      color: request.success ? '#2E7D32' : '#C62828',
      timeout: 5500,
    })
    this.showModalCadastrarAnestesista = false
    this.loadingCadastrarAnestesista = false
  }

  async confirmar() {
    await this.getSuporteAnestesistasStore.postAnestesistaToHospital({ anestesistaId: this.selected[0].id })
  }

  @Watch('showModalAnestesistas')
  onChangeShowModalAnestesistas(value: boolean) {
    setTimeout(() => {
      if (value) {
        this.$refs.getInputSearch.focus()
      } else {
        this.$refs.getInputSearch.blur()
        this.getInputSearch = ''
        this.getSuporteAnestesistasStore.clearPagination()
        this.getSuporteAnestesistasStore.clearAnestesistas()
        this.resetSelectedAnestesista()
        this.getSuporteAnestesistasStore.setModal({ name: 'listaDeAnestesistas', value: false })
      }
    }, 100)
  }

  @Watch('showModalCadastrarAnestesista')
  onChangeShowModalCadastrarAnestesista(value: boolean) {
    if (!value) {
      this.novoAnestesista = { nome: '', documento: '', crm: '' }
      this.$refs.cadastroAnestesistaForm.resetValidation()
    }
  }
}

